import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HotelService } from '../services/hotel.service';
import { Hotel } from '../hotel';

import { MessageService } from '../services/message.service';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {
  @ViewChild('print') print: ElementRef

  model = new Hotel();
  profiles: any; rates: any;
  val1: any;
  rate: any;
  tp: any;
  tot: any;
  hotelorder: any = {potato:""};
  public now: Date = new Date();
  bill_no; order_id
  constructor(private hotelService: HotelService, private router: Router, private messageService: MessageService, private activatedroute: ActivatedRoute,private elementRef:ElementRef) { }
  extra_items:any = [];
  ngOnInit() {
    this.getUnits();
    this.getHotel();
    this.order_id = this.activatedroute.snapshot.params['id'];
    let order = { "order_id": this.order_id };
    this.hotelService
      .getHotelOrderById(order)
      .subscribe(response => {
        
        this.obj = { "hotelid": response.hotelid };
        this.hotelService
          .getHotelRates(this.obj)
          .subscribe(rates => {
            this.rates = rates[0];
            Object.assign(this.model, this.rates);
            this.model.total = 0;
              Object.keys(this.hotelorder).forEach(key=> {
                  if((key.substr(key.length - 4)) != "unit"){
                    // console.log(key)
                    if(key == "order_id" || key== "hotelid" || key == "order_date" || key == "status"){

                    }else{
                      this.model[key+"qty"] = this.hotelorder[key]
                      if(this.hotelorder[key] != undefined){
                        setTimeout(() => {
                          this.calc(this.hotelorder[key],key)  
                        }, 100);
                        
                      }
                    }
                    
                  }  
              }, 1000);

              
              
          })
        this.hotelorder = response;
        if(response.extra_items){
          this.extra_items = JSON.parse(response.extra_items)
        }

      })

    $(document).on('focus', 'input[readonly]', function () {
      this.blur();
    });

    this.tot = 0;
    this.model.bill_no = this.bill_no;

    this.model.time = this.now.toLocaleDateString("en-US");
    setInterval(() => {
      this.now = new Date();
    }, 1);

    $(document).on('focus', 'input[readonly]', function () {
      this.blur();
    });

    this.getBillNo();
  }

  getBillNo() {
    this.hotelService
      .getBillNos()
      .subscribe(profiles => {
        this.bill_no = parseInt(profiles) + 1;
        this.model.bill_no = this.bill_no;
        //console.log(this.bill_no);
      })
  }

  getHotel() {
    this.hotelService
      .getAllHotelinmaterial()
      .subscribe(profiles => {
        this.profiles = profiles;
        //console.log(profiles);
      })
  }

  obj: any;
  getHotelRates(val) {
    $("#save").removeAttr('disabled');
    $("#save").css("display", "block");
    $("input[name$='qty']").val("0");
    $("input[name$='amt']").val("0");
    $("input").css("border", "1px solid #ccc");
    this.obj = { "hotelid": val };
    this.hotelService
      .getHotelRates(this.obj)
      .subscribe(rates => {
        this.rates = rates[0];
        Object.assign(this.model, this.rates);
        this.model.total = 0;

      })
  }
  pp: any = 0;
  calc(qty, mat) {
    // console.log(qty,mat)
    this.rate = this.model[mat];
    this.tp = mat + "amt";
    // console.log(this.rate)
    if(this.rate == undefined){
      this.rate = 0;
    }
    $("input[name~=" + this.tp + "]").val(this.rate * qty);
    let p = this.tp;
    this.model[p] = this.rate * qty
    this.addall();
  }


  addHotelBill() {
    $("#save").attr('disabled', 'disabled');
    $("#save").css("display", "none");
    $("input").css("border", "none");
    $("select").css("border", "none");
    this.model['extra_items'] = this.extra_items;
    this.hotelService
      .addHotelBill(this.model)
      .subscribe(responses => {
        let hotel = this.model.hotelid;
        let data = { "hotelid": hotel, "order_id": this.order_id }
        this.hotelService
          .orderStatus(data)
          .subscribe(response => {

          });
        this.hotelService
          .addHotelname(data)
          .subscribe(response => {
            this.model.hotelname = response;
            let billnum = this.model.bill_no;
            let hotelname = this.model.hotelname;
            this.router.navigate(['viewbill/'+billnum]);
          });
      })
  }

  prints() {
    $(".no-print").css("display","none");
    $(".order").css("display","none");
    $(".item").removeClass("col-xs-1").addClass("col-xs-2");
    window.print()
    $(".no-print").css("display","inline-block");
    $(".order").css("display","block");
    $(".item").removeClass("col-xs-2").addClass("col-xs-1");    
  }


  p1; p2; p3; p4; p5; p6; p7; p8; p9; p10; p11; p12; p13; p14; p15; p16; p17; p18; p19; p20; p21; p22; p23; p24; p25; p26; p27; p28; p29; p30; p31; p32; p33; p34; p35; p36; p37; p38; p39; p40; p41; p42; p43; p44; p45; p46; p47; p48; p49; p50; p51; p52; p53; p54; p55; p56; p57; p58; p59; p60; p61; p62; p63; p64; p65; p66; p67; p68; p69; p70; p71; p72; p73; p74; p75; p76; p77; p78; p79; p80; p81;
  addall() {
    this.p1 = $("input[name~=potatoamt]").val()?$("input[name~=potatoamt]").val():0;
    this.p2 = $("input[name~=onionamt]").val()?$("input[name~=onionamt]").val():0;
    this.p3 = $("input[name~=tomatoamt]").val()?$("input[name~=tomatoamt]").val():0;
    this.p4 = $("input[name~=garlicamt]").val()?$("input[name~=garlicamt]").val():0;
    this.p5 = $("input[name~=gingeramt]").val()?$("input[name~=gingeramt]").val():0;
    this.p6 = $("input[name~=greenchillyamt]").val()?$("input[name~=greenchillyamt]").val():0;
    this.p7 = $("input[name~=cabbageamt]").val()?$("input[name~=cabbageamt]").val():0;
    this.p8 = $("input[name~=caulifloweramt]").val()?$("input[name~=caulifloweramt]").val():0;
    this.p9 = $("input[name~=beansamt]").val()?$("input[name~=beansamt]").val():0;
    this.p10 = $("input[name~=cucumberamt]").val()?$("input[name~=cucumberamt]").val():0;

    this.p11 = $("input[name~=carrotamt]").val()?$("input[name~=carrotamt]").val():0;
    this.p12 = $("input[name~=beetrootamt]").val()?$("input[name~=beetrootamt]").val():0;
    this.p13 = $("input[name~=brinjalamt]").val()?$("input[name~=brinjalamt]").val():0;
    this.p14 = $("input[name~=drumstickamt]").val()?$("input[name~=drumstickamt]").val():0;
    this.p15 = $("input[name~=pumkingamt]").val()?$("input[name~=pumkingamt]").val():0;
    this.p16 = $("input[name~=battalegamt]").val()?$("input[name~=battalegamt]").val():0;
    this.p17 = $("input[name~=lemonamt]").val()?$("input[name~=lemonamt]").val():0;
    this.p18 = $("input[name~=capsicumamt]").val()?$("input[name~=capsicumamt]").val():0;
    this.p19 = $("input[name~=ladyfingeramt]").val()?$("input[name~=ladyfingeramt]").val():0;
    this.p20 = $("input[name~=karelaamt]").val()?$("input[name~=karelaamt]").val():0;

    this.p21 = $("input[name~=tondaliamt]").val()?$("input[name~=tondaliamt]").val():0;
    this.p22 = $("input[name~=arriamt]").val()?$("input[name~=arriamt]").val():0;
    this.p23 = $("input[name~=matakiamt]").val()?$("input[name~=matakiamt]").val():0;
    this.p24 = $("input[name~=sweetpotatoamt]").val()?$("input[name~=sweetpotatoamt]").val():0;
    this.p25 = $("input[name~=redchillyamt]").val()?$("input[name~=redchillyamt]").val():0;
    this.p26 = $("input[name~=rawpapaiamt]").val()?$("input[name~=rawpapaiamt]").val():0;
    this.p27 = $("input[name~=rawbananaamt]").val()?$("input[name~=rawbananaamt]").val():0;
    this.p28 = $("input[name~=coconutamt]").val()?$("input[name~=coconutamt]").val():0;
    this.p29 = $("input[name~=rawmangoamt]").val()?$("input[name~=rawmangoamt]").val():0;
    this.p30 = $("input[name~=appleamt]").val()?$("input[name~=appleamt]").val():0;

    this.p31 = $("input[name~=greenappleamt]").val()?$("input[name~=greenappleamt]").val():0;
    this.p32 = $("input[name~=orangeamt]").val()?$("input[name~=orangeamt]").val():0;
    this.p33 = $("input[name~=orangelamt]").val()?$("input[name~=orangelamt]").val():0;
    this.p34 = $("input[name~=watermilanamt]").val()?$("input[name~=watermilanamt]").val():0;
    this.p35 = $("input[name~=tarbujamt]").val()?$("input[name~=tarbujamt]").val():0;
    this.p36 = $("input[name~=strawberryamt]").val()?$("input[name~=strawberryamt]").val():0;
    this.p37 = $("input[name~=kiriamt]").val()?$("input[name~=kiriamt]").val():0;
    this.p38 = $("input[name~=anaramt]").val()?$("input[name~=anaramt]").val():0;
    this.p39 = $("input[name~=bananaamt]").val()?$("input[name~=bananaamt]").val():0;
    this.p40 = $("input[name~=grepsamt]").val()?$("input[name~=grepsamt]").val():0;

    this.p41 = $("input[name~=pineappleamt]").val()?$("input[name~=pineappleamt]").val():0;
    this.p42 = $("input[name~=papaiamt]").val()?$("input[name~=papaiamt]").val():0;
    this.p43 = $("input[name~=mangoamt]").val()?$("input[name~=mangoamt]").val():0;
    this.p44 = $("input[name~=spinachamt]").val()?$("input[name~=spinachamt]").val():0;
    this.p45 = $("input[name~=grianderamt]").val()?$("input[name~=grianderamt]").val():0;
    this.p46 = $("input[name~=springonionamt]").val()?$("input[name~=springonionamt]").val():0;
    this.p47 = $("input[name~=radishamt]").val()?$("input[name~=radishamt]").val():0;
    this.p48 = $("input[name~=mintamt]").val()?$("input[name~=mintamt]").val():0;
    this.p49 = $("input[name~=methiamt]").val()?$("input[name~=methiamt]").val():0;
    this.p50 = $("input[name~=curryleavsamt]").val()?$("input[name~=curryleavsamt]").val():0;

    this.p51 = $("input[name~=dilleavesamt]").val()?$("input[name~=dilleavesamt]").val():0;
    this.p52 = $("input[name~=sarsoamt]").val()?$("input[name~=sarsoamt]").val():0;
    this.p53 = $("input[name~=lalsagamt]").val()?$("input[name~=lalsagamt]").val():0;
    this.p54 = $("input[name~=galangalamt]").val()?$("input[name~=galangalamt]").val():0;
    this.p55 = $("input[name~=tymamt]").val()?$("input[name~=tymamt]").val():0;
    this.p56 = $("input[name~=oreganoamt]").val()?$("input[name~=oreganoamt]").val():0;
    this.p57 = $("input[name~=rajmeryamt]").val()?$("input[name~=rajmeryamt]").val():0;
    this.p58 = $("input[name~=caporlinesamt]").val()?$("input[name~=caporlinesamt]").val():0;
    this.p59 = $("input[name~=rocketamt]").val()?$("input[name~=rocketamt]").val():0;
    this.p60 = $("input[name~=thairedchillyamt]").val()?$("input[name~=thairedchillyamt]").val():0;

    this.p61 = $("input[name~=redcabbageamt]").val()?$("input[name~=redcabbageamt]").val():0;
    this.p62 = $("input[name~=rypaperamt]").val()?$("input[name~=rypaperamt]").val():0;
    this.p63 = $("input[name~=aspraygusamt]").val()?$("input[name~=aspraygusamt]").val():0;
    this.p64 = $("input[name~=awakadoamt]").val()?$("input[name~=awakadoamt]").val():0;
    this.p65 = $("input[name~=bazilamt]").val()?$("input[name~=bazilamt]").val():0;
    this.p66 = $("input[name~=lemongrassamt]").val()?$("input[name~=lemongrassamt]").val():0;
    this.p67 = $("input[name~=lickamt]").val()?$("input[name~=lickamt]").val():0;
    this.p68 = $("input[name~=cherrytomatoamt]").val()?$("input[name~=cherrytomatoamt]").val():0;
    this.p69 = $("input[name~=pakchoyamt]").val()?$("input[name~=pakchoyamt]").val():0;
    this.p70 = $("input[name~=zukiniamt]").val()?$("input[name~=zukiniamt]").val():0;

    this.p71 = $("input[name~=chinesscabbageamt]").val()?$("input[name~=chinesscabbageamt]").val():0;
    this.p72 = $("input[name~=babypotatoamt]").val()?$("input[name~=babypotatoamt]").val():0;
    this.p73 = $("input[name~=icebragamt]").val()?$("input[name~=icebragamt]").val():0;
    this.p74 = $("input[name~=babycornamt]").val()?$("input[name~=babycornamt]").val():0;
    this.p75 = $("input[name~=brokaliamt]").val()?$("input[name~=brokaliamt]").val():0;
    this.p76 = $("input[name~=sweetcornamt]").val()?$("input[name~=sweetcornamt]").val():0;
    this.p77 = $("input[name~=mushroomamt]").val()?$("input[name~=mushroomamt]").val():0;
    this.p78 = $("input[name~=celeryamt]").val()?$("input[name~=celeryamt]").val():0;
    this.p79 = $("input[name~=parsleyamt]").val()?$("input[name~=parsleyamt]").val():0;
    this.p80 = $("input[name~=staphvegamt]").val()?$("input[name~=staphvegamt]").val():0;

    this.p81 = $("input[name~=transport]").val()?$("input[name~=transport]").val():0;
    // console.log(this.p81)

    this.model.total = parseFloat(this.p1) + parseFloat(this.p2) + parseFloat(this.p3) + parseFloat(this.p4) + parseFloat(this.p5) + parseFloat(this.p6) + parseFloat(this.p7) + parseFloat(this.p8) + parseFloat(this.p9) + parseFloat(this.p10)
      + parseFloat(this.p11) + parseFloat(this.p12) + parseFloat(this.p13) + parseFloat(this.p14) + parseFloat(this.p15) + parseFloat(this.p16) + parseFloat(this.p17) + parseFloat(this.p18) + parseFloat(this.p19) + parseFloat(this.p20)
      + parseFloat(this.p21) + parseFloat(this.p22) + parseFloat(this.p23) + parseFloat(this.p24) + parseFloat(this.p25) + parseFloat(this.p26) + parseFloat(this.p27) + parseFloat(this.p28) + parseFloat(this.p29) + parseFloat(this.p30)
      + parseFloat(this.p31) + parseFloat(this.p32) + parseFloat(this.p33) + parseFloat(this.p34) + parseFloat(this.p35) + parseFloat(this.p36) + parseFloat(this.p37) + parseFloat(this.p38) + parseFloat(this.p39) + parseFloat(this.p40)
      + parseFloat(this.p41) + parseFloat(this.p42) + parseFloat(this.p43) + parseFloat(this.p44) + parseFloat(this.p45) + parseFloat(this.p46) + parseFloat(this.p47) + parseFloat(this.p48) + parseFloat(this.p49) + parseFloat(this.p50)
      + parseFloat(this.p51) + parseFloat(this.p52) + parseFloat(this.p53) + parseFloat(this.p54) + parseFloat(this.p55) + parseFloat(this.p56) + parseFloat(this.p57) + parseFloat(this.p58) + parseFloat(this.p59) + parseFloat(this.p60)
      + parseFloat(this.p61) + parseFloat(this.p62) + parseFloat(this.p63) + parseFloat(this.p64) + parseFloat(this.p65) + parseFloat(this.p66) + parseFloat(this.p67) + parseFloat(this.p68) + parseFloat(this.p69) + parseFloat(this.p70)
      + parseFloat(this.p71) + parseFloat(this.p72) + parseFloat(this.p73) + parseFloat(this.p74) + parseFloat(this.p75) + parseFloat(this.p76) + parseFloat(this.p77) + parseFloat(this.p78) + parseFloat(this.p79) + parseFloat(this.p80)
      + parseFloat(this.p81) + this.sum;
  }

  fieldArray: Array<any> = [
    
  ];
  newAttribute: any = {};

  firstField = true;
  firstFieldName = 'First Item name';
  isEditItems: boolean;
  savefirst: boolean;
  addFieldValue(index) {
    this.savefirst = false;
    if (this.fieldArray.length <= 10) {
      this.fieldArray.push(this.newAttribute);
      this.newAttribute = {};
    } else {

    }
  }

  deleteFieldValue(index) {
    this.fieldArray.splice(index, 1);
  }

  onEditCloseItems() {
    this.isEditItems = !this.isEditItems;
    this.savefirst = true;
    
  }
  units: any;
  getUnits(){
    this.hotelService
      .getUnits({})
      .subscribe(profiles => {
        this.units = profiles;
        // console.log(profiles);
      })
  }
qtyz;ratez;sumz;new_extra_items = []; sum = 0;
  extracalc(id){
    this.sum = 0;
    // console.log(id)
    // id.amount = id.unit*id.rate;
    this.qtyz = $("#qty_"+id).val();
    this.ratez = $("#rate_"+id).val();

    this.sumz = parseFloat(this.qtyz) * parseFloat(this.ratez)
    $("#amount_"+id).val(this.sumz)
    this.addall();
   
    
    for (var i = 0; i < this.extra_items.length; i++) {
        this.extra_items[i].amount = (parseFloat(this.extra_items[i].qty)) * (parseFloat(this.extra_items[i].rate)?parseFloat(this.extra_items[i].rate):0)
    }
// this.xyz();
    this.extra_items.forEach(element => {
      this.sum += ((element.qty?parseFloat(element.qty):0) * (element.rate?parseFloat(element.rate):0));
    });
    this.model.total+=this.sum;
  }

  xyz(){
    this.addall();
    let sum = 0;
    this.extra_items.forEach(element => {
      sum += element.amount;
    });
    this.model.total+=sum;
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/order/order.component.ts